module.exports = __webpack_public_path__ + "img/IMG_1024_L_WoodMatted_MockedUp.6f29b37c.jpg";